<template>
  <v-app>
    <!-- Main content -->
    <main>
      <!-- Show BaseLayout for authenticated users -->
      <BaseLayout v-if="isLoggedIn" />
      
      <!-- Show regular router-view for public pages when not logged in -->
      <router-view v-else />
    </main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
//import { useRoute } from 'vue-router';
import axios from 'axios';
import { useStore } from 'vuex';
import BaseLayout from './views/BaseLayout.vue';

const store = useStore();
//const router = useRouter();
//const route = useRoute();
const isLoading = ref(true);

const isLoggedIn = computed(() => !!store.state.user);

// Check if current route requires authentication
/*
const isProtectedRoute = computed(() => {
  return route.meta.requiresAuth;
});
*/
onMounted(async () => {
  try {
    // Initialize auth state from localStorage
    store.dispatch('initializeAuth');
    
    console.log('🌐 App: Initialization started');
    console.log('🌐 App: Stored token exists:', !!store.state.token);
    console.log('🌐 App: Stored user exists:', !!store.state.user);
    console.log('🌐 App: Axios Authorization header:', axios.defaults.headers.common['Authorization'] ? 'set' : 'not set');
    
    // Check if we have a stored token, if so verify the session
    if (store.state.token) {
      console.log('🌐 App: Using stored token for session check');
      console.log('🌐 App: Making request with Authorization header:', axios.defaults.headers.common['Authorization'] ? 'present' : 'missing');
      
      try {
        const res = await axios.get('/api/auth/session', {
          withCredentials: true
        });
        console.log('🌐 App: Session check successful');
        store.commit('setUser', res.data.user);
        // Update token if provided
        if (res.data.token) {
          store.commit('setToken', res.data.token);
        }
      } catch (error) {
        console.log('🌐 App: Session check failed with stored token');
        throw error;
      }
    } else {
      console.log('🌐 App: No stored token, trying session from cookie');
      // No stored token, try to get session from cookie
      const res = await axios.get('/api/auth/session', {
        withCredentials: true
      });
      console.log('🌐 App: Session check successful from cookie');
      store.commit('setUser', res.data.user);
      // If we get a user from session, store the token
      if (res.data.user && res.data.token) {
        store.commit('setToken', res.data.token);
      }
    }
  } catch (error) {
    console.log('Session check failed, clearing auth state');
    console.log('Error details:', error.response?.status, error.response?.data);
    store.commit('logout');
  } finally {
    isLoading.value = false;
  }
});
</script>
